import React, { useState } from "react";
import {
  Upload,
  message,
  Row,
  Col,
  Card,
  Form,
  Modal,
  Button,
  Input,
  Spin,
} from "antd";
import {
  RcFile,
  UploadChangeParam,
  UploadFile,
} from "antd/lib/upload/interface";
import { InboxOutlined } from "@ant-design/icons";
import { addAward, uploadImage } from "../../../utils/API";
import { Link, useNavigate } from "react-router-dom";
import { BiUpload } from "react-icons/bi";
import { FaArrowLeft } from "react-icons/fa";

const { Dragger } = Upload;

const AwardAdd: React.FC = () => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);
  const [previewVisible, setPreviewVisible] = useState<boolean>(false);
  const [previewImage, setPreviewImage] = useState<string>("");
  const [title, setName] = useState<string>("");
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate();

  const handleCancelPreview = () => setPreviewVisible(false);

  const onChange = (info: UploadChangeParam<UploadFile<any>>) => {
    setFileList(info.fileList);
  };

  const onPreview = async (file: UploadFile) => {
    try {
      const imageUrl = URL.createObjectURL(file.originFileObj as Blob);
      setPreviewImage(imageUrl);
      setPreviewVisible(true);
    } catch (error) {
      console.error("Error previewing image:", error);
      message.error("Failed to preview image");
    }
  };

  const handleSubmit = async (values: any) => {
    setLoading(true)
    if (fileList.length === 0) {
      message.error("Please select an image first");
      return;
    }

    if (!title.trim()) {
      message.error("Please enter a title");
      return;
    }
    setLoading(false)
    try {
      setLoading(true)
      const formData = new FormData();
      formData.append("title", values.title);
      if (fileList.length > 0) {
        fileList.forEach((file) => {
          formData.append("file", file.originFileObj as Blob);
        });
      }
      const imageUrl = await addAward(formData);
      message.success("Award Added successfully");
      setLoading(false)
      navigate("/backend/awards");
      // Do something with the imageUrl if needed
    } catch (error) {
      setLoading(false)
      console.error("Error Adding Award:", error);
      message.error("Failed to Adding Award");
    }
  };

  const handleImage = ({
    fileList: newFileList,
  }: {
    fileList: UploadFile[];
  }) => {
    // Display preview for the first file in fileList
    if (newFileList.length > 0) {
      const file = newFileList[0];
      const reader = new FileReader();
      reader.onload = (e) => {
        setPreviewImage(e.target?.result as string); // Set preview URL
      };
      reader.readAsDataURL(file.originFileObj as RcFile);
    } else {
      setPreviewImage(null as any); // Clear preview if fileList is empty
    }
    setFileList(newFileList); // Update fileList state
  };

  return (
    <div className="">
      <Row className="m-2" align="middle">
        <Col span={16}>
          <h2 className="text-2xl font-bold">Add Award</h2>
        </Col>

        <Col span={8} className="d-flex justify-end">
          <Link to={"/backend/awards"} >
            <button className="d-flex justify-content-center align-items-center w-full border btn-brand">
              <FaArrowLeft className="me-2" />
              <div className="ms-2">Back</div>
            </button>
          </Link>
        </Col>
      </Row>
      <Form className="bg-white" onFinish={handleSubmit}>
        <Card style={{ backgroundColor: "#ffffff" }}>
          <Row
            className="border border-warning-2 p-5 bg-white rounded-md"
            style={{ marginLeft: 0, marginRight: 0 }}
          >
            <Col xs={24} sm={24} md={24} xl={24} xxl={24}>
              <Row className="bg-white">
                <Col
                  span={24}
                  className="d-flex justify-content-start align-items-center"
                ></Col>
                <Col span={24}>
                  <Row>
                    <Col
                      xs={24} sm={24} md={4}
                      className="d-flex justify-content-start me-4 bg-white lg:mb-5"
                    >
                      <label className="font-bold">
                        Name <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col xs={24} sm={24} md={12}>
                      <Form.Item
                        name="title"
                        rules={[
                          {
                            required: true,
                            message: "Please Enter Name",
                          },
                        ]}
                      >
                        <Input
                          size="large"
                          className="rounded border border-1"
                          placeholder="Awards Title"
                          value={title}
                          onChange={(e) => setName(e.target.value)} // Update the title state when the input value changes
                        />
                      </Form.Item>
                    </Col>
                  </Row>
                </Col>
                <Col span={24} className="mb-5">
                  <Row>
                    <Col
                      xs={24} sm={24} md={4}
                      className="d-flex justify-content-start me-4 bg-white lg:mb-5"
                    >
                      <label className="font-bold">
                        Image <span className="text-danger">*</span>
                      </label>
                    </Col>
                    <Col
                      xs={24} sm={24} md={12}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <Upload
                        listType="picture-card"
                        name="file"
                        fileList={fileList}
                        onChange={handleImage}
                        maxCount={1}
                        accept=".png, .jpg, .jpeg"
                        beforeUpload={(file: { type: string; size: number; }) => {
                          // Validate file type and size
                          const isJpgOrPng =
                            file.type === "image/jpeg" ||
                            file.type === "image/png";
                          if (!isJpgOrPng) {
                            message.error("You can only upload JPG/PNG file!");
                          }
                          const isLt2M = file.size / 1024 / 1024 < 1;
                          if (!isLt2M) {
                            message.error("Image must be smaller than 1MB!");
                          }
                          return isJpgOrPng && isLt2M;
                        }}
                      >
                        {fileList.length === 0 ? (
                          <div>
                            <BiUpload />
                          </div>
                        ) : (
                          <img
                            src={previewImage}
                            alt="Preview"
                            style={{ width: "100%", height: "auto" }}
                          />
                        )}
                      </Upload>
                      <Modal
                        open={previewVisible}
                        footer={null}
                        onCancel={handleCancelPreview}
                      >
                        <img
                          alt="Preview"
                          style={{ width: "100%" }}
                          src={previewImage}
                        />
                      </Modal>
                    </Col>
                  </Row>
                </Col>
                <Col
                  span={20}
                  style={{
                    textAlign: "right",
                    justifyContent: "center",
                    display: "flex",
                  }}
                >
                  <button className="btn-brand" >
                    {
                      loading ? "Adding..." : "Add"
                    }
                  </button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Card>
      </Form>
    </div>
  );
};

export default AwardAdd;
